wbApp.controller('SurveyAnswerDetailCtrl', ['$scope', 'surveyResponseSvc',
function ($scope, surveyResponseSvc) {
    // $scope.survey
    // $scope.surveyResponseID

    $scope.response = surveyResponseSvc.getByResponseIDAyns($scope.surveyResponseID);

    $scope.response.$promise.then(function (response) {
        $scope.model = surveyResponseSvc.getQuestionWithAnswersModel(
            $scope.survey.surveyQuestions,
            response.responseAnswers);
    });

}]);
